import React from 'react';

//interfaces
import { IConditionalOptions, IConditionalTextInput } from '../../interfaces/IConditionalLogicPanel';

//components
import ToggleConditionalValue from './ToggleConditionalValue';
import TextConditionalValue from './TextConditionalValue';



const ConditionalValue = ({textConditions, toggleConditions, onAddConditionalValueClick } : {textConditions?: IConditionalTextInput[], toggleConditions?: IConditionalOptions[], onAddConditionalValueClick?: () => void} ) => {
    
    if (!textConditions && !toggleConditions) {
        return <></>
    }
    if (toggleConditions) {
        return <ToggleConditionalValue conditions={toggleConditions} onAddConditionalValueClick={onAddConditionalValueClick} />
    }
    
    else if (textConditions) {
        return <TextConditionalValue conditions={textConditions}  />
    }
};

export default ConditionalValue